import { Injectable, Pipe, PipeTransform } from '@angular/core';

@Pipe({
 name: 'imageSize'
})

@Injectable()
export class ImgFilter implements PipeTransform {
	transform( images: any[], value: string ): any[] {
		if ( !images || !value )
			return images;
		
		return images.filter( (image) => {
			var image = image.size ? image.size.toLowerCase() : null;
				value = value.toLowerCase();
		 	if ( image )
		 		return image.indexOf(value) !== -1;
		});
	}
}


// WEBPACK FOOTER //
// C:/Users/Asylum/identity-vagrant/src/asylum-idenetity/src/app/pipes/image.filter.pipe.ts